<script>
    import { resumeGame, newGame, gameState, resetGame } from "../store";

    export let genre;
    export let score;
    export let maxScore;

    export let backgroundImage;

    let progressBarValue = "100%";

    gameState.subscribe((state) => {
        progressBarValue = state.progressBarValue;
    });

    let bgImageTemplate = `background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url("${backgroundImage}");`;
</script>

<style>
    .custom-white {
        background-color: #f1f1f1;
        color: #1f1f1f;
    }
</style>

<div class="container pause-screen" style={bgImageTemplate}>
    <div class="div-block-6" style={`width: ${progressBarValue}%`} />
    <div class="score-wrap vertical">
        <h3 class="heading2">{genre}</h3>
        <h3 class="heading2 score">{score}/{maxScore}</h3>
    </div>

    <div class="button-wrap">
        <div
            class="button-hero screen
            w-button"
            on:click={resumeGame}>
            Продолжить
        </div>

        <div on:click={resetGame} class="button-hero screen w-button">Заново</div>

        <a
            href="/"
            class="button-hero screen w-button custom-white">
            На главную
        </a>
    </div>
</div>
